import type { SVGProps } from "react";

export function IconWhiteTicTacToe(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M8 8L22 22M8 22L22 8M42 42L56 56M42 56L56 42M32 7V57M57 32L7 32M57 15C57 19.4183 53.4183 23 49 23C44.5817 23 41 19.4183 41 15C41 10.5817 44.5817 7 49 7C53.4183 7 57 10.5817 57 15ZM23 49C23 53.4183 19.4183 57 15 57C10.5817 57 7 53.4183 7 49C7 44.5817 10.5817 41 15 41C19.4183 41 23 44.5817 23 49Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
